<template>
  <a v-if="isLink" :class="className">{{text}}</a>

  <button v-else :class="className">{{text}}</button>
</template>

<script>
export default {
  name: "Button",
  props: ["isLink", "className", "text"]
};
</script>
